import { Navigate } from "react-router-dom";
import { useAuth } from "../Context/MyContext";
import Loader from "../Common/Loader/Loader";

const ProtectedRoute = ({ children }) => {
    const { empData, loadingAuth } = useAuth();
    const savedUser = localStorage.getItem("empData");

    if (loadingAuth) {
        return (
            <div className="flex justify-center items-center h-screen">
                <Loader/>
            </div>
        )
    }

    if (!empData && !savedUser) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;